import { render, staticRenderFns } from "./SkillImportModal.vue?vue&type=template&id=2633569c&scoped=true&"
import script from "./SkillImportModal.vue?vue&type=script&lang=js&"
export * from "./SkillImportModal.vue?vue&type=script&lang=js&"
import style0 from "./SkillImportModal.vue?vue&type=style&index=0&id=2633569c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633569c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2633569c')) {
      api.createRecord('2633569c', component.options)
    } else {
      api.reload('2633569c', component.options)
    }
    module.hot.accept("./SkillImportModal.vue?vue&type=template&id=2633569c&scoped=true&", function () {
      api.rerender('2633569c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/SkillImportModal.vue"
export default component.exports